<!-- FORM TO DEFINE THE EMPLOYEE ROLE TO BE TARGETED -->
<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <!-- Page Header - Title -->
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">
          {{
          $t("campaigns.createnew")
          }}
        </span>
        <h3 class="page-title">{{ $t("campaigns.contactpoints") }}</h3>
      </d-col>
    </d-row>
    <!-- End Page Header - Title -->

    <d-col lg="12">
      <d-progress theme="success" :value="100" :max="100" />
    </d-col>

    <d-col lg="12" class="mx-auto mt-4">
      <!-- Seniority-->
      <d-card class="card-small mb-4">
        <d-card-body class="px-4 pb-2">
          <d-form>
            <d-form-row>
              <d-col lg="12" class="mb-3">
                <d-form-text tag="h6" class="m-0">
                  {{
                  $t("campaigns.employeelevel")
                  }}
                </d-form-text>
                <d-form-text tag="p" class="text-muted m-0 mb-2">
                  {{
                  $t("campaigns.employeelevelsub")
                  }}
                </d-form-text>
              </d-col>
            </d-form-row>
            <!-- Seniority Checkboxes-->
            <d-form-row>
              <form class="mt-2 campaign-checkbox">
                <span v-for="level in levels" :key="level.value">
                  <input
                    class="checkbox-tools"
                    type="checkbox"
                    :name="level.label"
                    :id="level.value"
                    v-model="level.isSelected"
                    @click="selectSeniority(level)"
                  />
                  <label
                    class="for-checkbox-tools checkbox-resizer"
                    :for="level.value"
                  >{{ level.label }}</label>
                </span>
              </form>
            </d-form-row>
          </d-form>
        </d-card-body>
      </d-card>
      <!-- End Seniority -->

      <!-- Employee Type / Role -->
      <d-card class="card-small mb-4">
        <d-card-body class="px-4 pb-2">
          <d-form>
            <d-form-row>
              <d-col lg="12" class="mb-3">
                <d-form-text tag="h6" class="m-0">
                  {{
                  $t("campaigns.employeerole")
                  }}
                </d-form-text>
                <d-form-text tag="p" class="text-muted m-0 mb-2">
                  {{
                  $t("campaigns.employeerolesub")
                  }}
                </d-form-text>
                <!-- <vue-simple-suggest
                  class="float-right"
                  :placeholder="$t('campaigns.employeerolesearch')"
                  v-model="chosen"
                  :list="roleSuggestionList"
                  :filter-by-query="true"
                ></vue-simple-suggest>-->
              </d-col>
            </d-form-row>
            <!-- Role Checkboxes-->
            <d-form-row class="mb-2">
              <form class="mt-2 campaign-checkbox">
                <span v-for="role in filteredRoles" :key="role.value">
                  <input
                    class="checkbox-tools"
                    type="checkbox"
                    :name="role.value"
                    :id="role.value"
                    v-model="role.isSelected"
                    @click="selectRole(role)"
                  />
                  <label
                    class="for-checkbox-tools checkbox-resizer"
                    :class="{ 'highlightitem': ( role.label === chosen ) }"
                    :for="role.value"
                  >{{ role.label }}</label>
                </span>
              </form>
            </d-form-row>
            <!-- Sub Role
            <d-form-row v-for="role in roles" :key="role.role">
              <div v-if="role.isSelected">
                <d-form class="m-2 campaign-checkbox">
                  <d-form-text tag="p" class="text-muted m-0 mb-4">
                    <u class="ind-text color-accent">{{ role.name }}</u>
                    <br />sub categories
                    <span>
                      <d-button size="sm" outline pill class="resize-pill m-2" theme="success">
                        <i class="material-icons">&#XE145;</i> Select All
                      </d-button>
                      <d-button
                        size="sm"
                        outline
                        pill
                        class="resize-pill my-2 mr-2"
                        theme="warning"
                      >
                        <i class="material-icons">remove</i> Unselect All
                      </d-button>
                    </span>
                  </d-form-text>
                </d-form>
                <span class="float-left">
                  <span v-for="sub in role.sub" :key="sub.role">
                    <input
                      class="checkbox-tools"
                      type="checkbox"
                      :name="sub.role"
                      :id="sub.role"
                      v-model="sub.isSelected"
                    />
                    <label
                      class="for-checkbox-tools checkbox-sub"
                      @click="selectedSub(sub)"
                      :for="sub.role"
                    >{{ sub.role }}</label>
                  </span>
                </span>
              </div>
            </d-form-row>
            End Sub Role-->
          </d-form>
        </d-card-body>
      </d-card>
      <!-- End Role -->

      <!-- Language Preference -->
      <!--
      <d-card class="card-small edit-user-details mb-4">
        <d-card-header class="p-0"></d-card-header>
        <d-card-body class="p-0">
          <d-form class="py-4">
            <d-form-row class="mx-4">
              <d-col lg="8">
                <d-form-text tag="h6" class="m-0">Primary Language</d-form-text>
                <d-form-text
                  tag="p"
                  class="text-muted m-0"
                >Separate contacts by the languages they use</d-form-text>
                <d-input
                  class="mt-4"
                  type="text"
                  id="campaignName"
                  placeholder="ex: English, French, Japanese"
                />
              </d-col>
            </d-form-row>
          </d-form>
        </d-card-body>
      </d-card>
      -->
      <!-- End Language Preference  -->
      <!-- Finish -->
      <d-card class="mb-4">
        <d-card-footer class="form-end">
          <d-row class="py-2">
            <!-- Showing Percentage Progress -->
            <span class="w-100 pl-3">
              <!-- <div>
                <d-button class="outline form-back-btn" @click="navigateBack()">Back</d-button>
              </div>-->
              <div>
                <d-button
                  size="sm"
                  class="btn-accent btn-form-end ml-auto d-table mr-3"
                  @click="createCampaign()"
                  :disabled="isCampaignLoading"
                >{{ isCampaignLoading ? "Loading..." : "Finish" }}</d-button>
                <span class="pretext-btn pt-1 text-right">
                  {{ $t("campaigns.finishpretext") }}
                  <i class="material-icons">arrow_forward</i>
                </span>
              </div>
            </span>
          </d-row>
        </d-card-footer>
      </d-card>

      <!-- End Finish -->
    </d-col>
    <!-- ERROR MODAL -->
    <d-modal v-if="showErrorModal" @close="handleClose">
      <d-modal-header>
        <d-modal-title>😅 Whoops!</d-modal-title>
      </d-modal-header>
      <d-modal-body class="modal-text-resize blue-text pb-3">
        <strong>No companies were found for your selections</strong>
      </d-modal-body>
      <d-modal-body class="modal-text-resize pt-0">
        Try selecting more industries, sub industries, or employee role types
        to generate prospects.
        <!-- BUTTON TO ADD MORE INDUSTRIES -->
        <d-btn @click="addMoreIndustries()" style="margin-top:15px;">Add more industries</d-btn>
      </d-modal-body>
    </d-modal>
  </d-container>
</template>

<script>
import _ from "lodash";
import constants from "@/data";
import { CAMPAIGN_SET_NEW, CAMPAIGN_CREATE, AUTH_REFRESH } from "@/store/types";
import { mapGetters } from "vuex";
import VueSimpleSuggest from "vue-simple-suggest";

export default {
  components: {
    VueSimpleSuggest
  },
  computed: {
    ...mapGetters([
      "getNewCampaign",
      "getCurrentCampaign",
      "isCampaignLoading"
    ]),
    filteredRoles() {
      return this.roles;
    }
  },
  mounted() {
    this.roles = constants.employee().roleList;
    this.levels = constants.employee().seniority;
    this.roleSuggestionList = constants.employee().roleSuggestionList;

    if (this.getNewCampaign) {
      this.newCampaign = _.cloneDeep(this.getNewCampaign);
      this.roles = this.roles.map(role => {
        if (this.newCampaign.roles.includes(role.value)) {
          role.isSelected = true;
        }
        return role;
      });
      this.levels = this.levels.map(level => {
        if (this.newCampaign.seniority.includes(level.value)) {
          level.isSelected = true;
        }
        return level;
      });
    }
  },
  data() {
    return {
      showErrorModal: false,
      chosen: "",
      newCampaign: {},
      levels: [],
      roles: [],
      roleSuggestionList: [],
      selected: null,
      options: [
        { value: null, text: "Globally" },
        { value: "USA", text: "United States" },
        { value: "USA", text: "United States" },
        { value: "UK", text: "United Kingdom" },
        { value: "KR", text: "Korean" },
        { value: "JP", text: "Japan" }
      ],
      sliderValue: ["10", "80"]
    };
  },
  methods: {
    selectSub(sub) {
      sub.isSelected = !sub.isSelected;
    },
    setNewCampaign() {
      const roles = this.roles
        .filter(role => role.isSelected)
        .map(role => role.value);

      const seniority = this.levels
        .filter(level => level.isSelected)
        .map(level => level.value);

      this.$store.commit(CAMPAIGN_SET_NEW, {
        ...this.newCampaign,
        roles,
        seniority
      });
    },
    addMoreIndustries() {
      this.handleClose();
      this.navigateBack();
    },
    navigateBack() {
      this.setNewCampaign();
      this.$router.back(() => {
        window.scrollTo(0, 0);
      });
    },
    async createCampaign() {
      this.setNewCampaign();

      try {
        await this.$store.dispatch(CAMPAIGN_CREATE, {
          ...this.getNewCampaign
        });
        await this.$store.dispatch(AUTH_REFRESH);
        this.$router.push({
          name: "campaign-companies",
          params: { id: this.getCurrentCampaign._id }
        });
      } catch (err) {
        // If no companies are found with search criteria,
        // show error modal
        if (err.response.status === 404) {
          this.handleShowError();
        }
      }
    },
    selectRole(role) {
      role.isSelected = !role.isSelected;
    },
    selectSeniority(level) {
      level.isSelected = !level.isSelected;
    },
    //ERROR MODAL HANDLER
    handleShowError() {
      this.showErrorModal = true;
    },
    handleClose() {
      this.showErrorModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-text-resize {
  font-size: 1.1rem;
  color: #3d5170;
}

.blue-text {
  color: #007bff;
}

.z-20 {
  z-index: 20;
}

.resize-pill {
  padding: 5px 13px 4px 10px;
}

.ind-text {
  text-decoration: none;
  font-weight: bold;
}
.default-input.designed {
  height: auto;
  line-height: 1.5;
  background-color: #fff;
  border: 1px solid #d8d8d8 !important;
  will-change: border-color, box-shadow;
  border-radius: 0.25rem;
  box-shadow: none;
  transition: box-shadow 250ms cubic-bezier(0.27, 0.01, 0.38, 1.06),
    border 250ms cubic-bezier(0.27, 0.01, 0.38, 1.06);
  &:hover {
    border-color: #cacaca !important;
  }
  &:focus-within {
    border-color: #007bff !important;
    box-shadow: 0 0.313rem 0.719rem rgba(0, 123, 255, 0.1),
      0 0.156rem 0.125rem rgba(0, 0, 0, 0.06) !important;
  }
}
</style>
